export default __webpack_public_path__ + "static/media/github.ff37daf3.svg";